let bankLogo = {}
let bankList  =[
    {label:'中国银行',value:'BOC',logo:bankLogo.BOC},
    {label:'中国农业银行',value:'ABC',logo:bankLogo.ABC},
    {label:'中国工商银行',value:'ICBC',logo: bankLogo.ICBC},
    {label:'中国建设银行',value:'CCB', logo: bankLogo.CCB,},
    {label:'交通银行',value:'COMM',logo: bankLogo.COMM,},
    {label:'中国邮政储蓄银行',value:'PSBC',logo: bankLogo.PSBC,},
    {label:'招商银行',value:'CMB',logo: bankLogo.CMB,},
    {label:'中国民生银行',value:'CMBC',logo: bankLogo.CMBC,},
    {label:'中信银行',value:'CITIC',logo: bankLogo.CITIC,},
    {label:'中国光大银行',value:'CEB',logo: bankLogo.CEB,},
    {label:'华夏银行',value:'HXB',logo: bankLogo.HXB,},
    {label:'广发银行',value:'GDB', logo: bankLogo.GDB,},
    {label:'深圳发展银行',value:'SDB',logo: bankLogo.BOC,},
    {label:'兴业银行',value:'CIB',logo: bankLogo.CIB,},
    {label:'浦东发展银行',value:'SPDB',logo: bankLogo.SPDB,},
    {label:'恒丰银行',value:'EGB', logo: bankLogo.BOC,},
    {label:'齐鲁银行',value:'QLBANK',logo: bankLogo.BOC,},
    {label:'烟台商业银行',value:'YTB'},
    {label:'潍坊银行',value:'WFCCB'},
    {label:'临沂商业银行',value:'LSB'},
    {label:'浙商银行',value:'CZB'},
    {label:'渤海银行',value:'CBHB'},
    {label:'上海银行',value:'SHB', logo: bankLogo.SHB,},
    {label:'厦门银行',value:'XMCCB'},
    {label:'北京银行',value:'BJB',logo: bankLogo.BJB,},
    {label:'福建海峡银行',value:'FJHXB'},
    {label:'宁波银行',value:'NBB'},
    {label:'平安银行',value:'SPAB',logo: bankLogo.SPAB,},
    {label:'焦作市商业银行',value:'JZCB'},
    {label:'温州银行',value:'WZCB'},
    {label:'广州银行',value:'GCB'},
    {label:'汉口银行',value:'HKBC'},
    {label:'龙江银行',value:'DAQINGB'},
    {label:'盛京银行',value:'SJB'},
    {label:'洛阳银行',value:'BOLY'},
    {label:'大连银行',value:'DLB'},
    {label:'苏州市商业银行',value:'SZB'},
    {label:'南京银行',value:'NJCB'},
    {label:'东莞市商业银行',value:'DGB'},
    {label:'金华银行',value:'JHCCB'},
    {label:'乌鲁木齐市商业银行',value:'URMQCCB'},
    {label:'绍兴银行',value:'SXCCB'},
    {label:'成都市商业银行',value:'BCD'},
    {label:'抚顺银行',value:'FSB'},
    {label:'葫芦岛市商业银行',value:'HLDB'},
    {label:'郑州银行',value:'ZZB'},
    {label:'宁夏银行',value:'YCCCB'},
    {label:'珠海华润银行',value:'CRB'},
    {label:'齐商银行',value:'QSB'},
    {label:'锦州银行',value:'BOJZ'},
    {label:'徽商银行',value:'HSB'},
    {label:'重庆银行',value:'CQB'},
    {label:'哈尔滨银行',value:'HEBB'},
    {label:'贵阳银行',value:'GYB'},
    {label:'西安银行',value:'XAB'},
    {label:'无锡市商业银行',value:'WRCB'},
    {label:'丹东银行',value:'DDB'},
    {label:'兰州银行',value:'LZB'},
    {label:'南昌银行',value:'NCB'},
    {label:'晋商银行',value:'JSHB'},
    {label:'青岛商行',value:'QDCCB'},
    {label:'吉林市商业银行',value:'JLB'},
    {label:'九江银行',value:'JJCCB'},
    {label:'鞍山市商业银行',value:'BOAS'},
    {label:'秦皇岛市商业银行',value:'QHDB'},
    {label:'青海银行',value:'QHB'},
    {label:'台州银行',value:'TZCB'},
    {label:'长沙银行',value:'CSCB'},
    {label:'赣州银行',value:'GZCCB'},
    {label:'泉州市商业银行',value:'QZCCB'},
    {label:'营口市商业银行',value:'BOYK'},
    {label:'阜新银行',value:'FXB'},
    {label:'嘉兴市商业银行',value:'JXCCB'},
    {label:'廊坊银行',value:'LCCB'},
    {label:'泰隆城市信用社',value:'ZJTLCRU'},
    {label:'内蒙古银行',value:'BOIMC'},
    {label:'湖州市商业银行',value:'HZCCB'},
    {label:'沧州银行',value:'BOCZ'},
    {label:'威海市商业银行',value:'WHSHB'},
    {label:'攀枝花市商业银行',value:'PZHCCB'},
    {label:'绵阳市商业银行',value:'MYSYYH'},
    {label:'泸州市商业银行',value:'LZCCB'},
    {label:'大同市商业银行',value:'DTCCB'},
    {label:'三门峡市商业银行',value:'SMXB'},
    {label:'江苏长江商业银行',value:'CJCCB'},
    {label:'柳州银行',value:'LZHCCB'},
    {label:'南充市商业银行',value:'CGNB'},
    {label:'莱商银行',value:'LSBC'},
    {label:'唐山市商业银行',value:'TSB'},
    {label:'六盘水商行',value:'LPSB'},
    {label:'曲靖市商业银行',value:'QJCCB'},
    {label:'晋城银行',value:'JCCB'},
    {label:'江苏银行',value:'JSB'},
    {label:'长治市商业银行',value:'CZCCB'},
    {label:'承德银行',value:'CDB'},
    {label:'德州银行',value:'DZB'},
    {label:'遵义市商业银行',value:'ZYB'},
    {label:'邯郸市商业银行',value:'HDCB'},
    {label:'安顺市商业银行',value:'ASHB'},
    {label:'玉溪市商业银行',value:'YXCCB'},
    {label:'浙江民泰商业银行',value:'MTBANK'},
    {label:'上饶银行',value:'SRB'},
    {label:'东营市商业银行',value:'DYCCB'},
    {label:'泰安市商业银行',value:'TACCB'},
    {label:'浙江稠州商业银行',value:'CZCB'},
    {label:'乌海银行',value:'WHCB'},
    {label:'自贡市商业银行',value:'ZGB'},
    {label:'鄂尔多斯银行',value:'ORBANK'},
    {label:'鹤壁银行',value:'HBSB'},
    {label:'许昌市商业银行',value:'XCCB'},
    {label:'济宁银行',value:'JNB'},
    {label:'铁岭市商业银行',value:'BOTL'},
    {label:'乐山市商业银行',value:'LSCCB'},
    {label:'长安银行',value:'CCABC'},
    {label:'重庆三峡银行',value:'CCQTGB'},
    {label:'石嘴山银行',value:'SZSCCB'},
    {label:'盘锦市商业银行',value:'PJB'},
    {label:'昆仑银行',value:'KLB'},
    {label:'平顶山银行',value:'PDSCB'},
    {label:'朝阳市商业银行',value:'CYCB'},
    {label:'遂宁市商业银行',value:'SNCCB'},
    {label:'保定市商业银行',value:'BOBD'},
    {label:'邢台银行',value:'XTB'},
    {label:'凉山州商业银行',value:'LSZSH'},
    {label:'漯河商行',value:'LHB'},
    {label:'达州市商业银行',value:'DZCCB'},
    {label:'新乡市商业银行',value:'XXSSH'},
    {label:'晋中市商业银行',value:'JZB'},
    {label:'驻马店市商业银行',value:'ZMDB'},
    {label:'衡水市商业银行',value:'HSMB'},
    {label:'周口市商业银行',value:'ZKB'},
    {label:'阳泉市商业银行',value:'YQCCB'},
    {label:'宜宾市商业银行',value:'YBCCB'},
    {label:'库尔勒市商业银行',value:'XJKCCB'},
    {label:'雅安市商业银行',value:'YACCB'},
    {label:'商丘商行',value:'SQB'},
    {label:'安阳市商业银行',value:'AYB'},
    {label:'信阳银行',value:'XYCB'},
    {label:'华融湘江银行',value:'HRXJB'},
    {label:'上海农村信用社',value:'SRCB'},
    {label:'昆山农信社',value:'JSNXB'},
    {label:'常熟农村商业银行',value:'CSRCB'},
    {label:'广州农村商业银行',value:'GRCB'},
    {label:'佛山顺德农村商业银行',value:'SDEB'},
    {label:'湖北农村信用社',value:'HBXH'},
    {label:'江阴农村商业银行',value:'JRCB'},
    {label:'重庆农村商业银行',value:'CRCB'},
    {label:'山东省农村信用社',value:'SDNXS'},
    {label:'东莞农村商业银行',value:'DRCB'},
    {label:'张家港农村商业银行',value:'ZRCB'},
    {label:'福建省农村信用社',value:'FJNXB'},
    {label:'北京农村商业银行',value:'BJRCB'},
    {label:'天津农村商业银行',value:'TRCB'},
    {label:'鄞州银行',value:'YZB'},
    {label:'成都农村商业银行',value:'CDRCB'},
    {label:'江苏省农村信用社',value:'JSNX'},
    {label:'吴江农商行',value:'WJRCB'},
    {label:'浙江省农村信用社',value:'ZJRCC'},
    {label:'珠海农村信用社',value:'ZHRCU'},
    {label:'太仓农村商业银行',value:'TCRCB'},
    {label:'贵州省农村信用社',value:'GZNXB'},
    {label:'无锡农村商业银行',value:'WXRCB'},
    {label:'江西农信联合社',value:'JXNXS'},
    {label:'河南省农村信用社',value:'HNNX'},
    {label:'陕西省农村信用社',value:'SXNXS'},
    {label:'广西农村信用社',value:'GXRCU'},
    {label:'新疆农村信用社',value:'XJCCB'},
    {label:'吉林农信联合社',value:'JLNLS'},
    {label:'黄河农村商业银行',value:'BYW'},
    {label:'安徽省农村信用社',value:'AHRCU'},
    {label:'青海省农村信用社',value:'QHYHXH'},
    {label:'广东省农村信用社',value:'GDRCU'},
    {label:'内蒙古农村信用社',value:'NMGNXS'},
    {label:'四川省农村信用社',value:'SCRCU'},
    {label:'甘肃省农村信用社',value:'GSRCU'},
    {label:'辽宁省农村信用社',value:'LNRCC'},
    {label:'山西省农村信用社',value:'SXINJ'},
    {label:'天津滨海农村商业银行',value:'TJBHB'},
    {label:'黑龙江省农村信用社',value:'HLJRCC'},
    {label:'青岛即墨北农商村镇银行',value:'QDJMB'},
    {label:'浙江长兴联合村镇银行',value:'ZJCURB'},
    {label:'深圳龙岗鼎业村镇银行',value:'EDRB'},
    {label:'中山小榄村镇银行',value:'ZSXLB'},
    {label:'深圳福田银座村镇银行',value:'FTYZB'},
    {label:'杭州市商业银行',value:'HZCB'},
    {label:'日照银行',value:'BORZ'},
    {label:'富滇银行',value:'FDB'},
    {label:'浙江泰隆商业银行',value:'ZJTLCB'},
    {label:'广西北部湾银行',value:'BOBBG'},
    {label:'桂林银行',value:'GLB'},
    {label:'上海农村商业银行',value:'SHRCB'},
    {label:'云南省农村信用社',value:'YNRCC'},
    {label:'河北省农村信用社',value:'HEBNX'},
    {label:'湖北银行',value:'HBB'},
    {label:'广州农村信用合作社',value:'GZCRU'},
    {label:'深圳市农村商业银行',value:'SZCRU'},
    {label:'景德镇商业银行',value:'BOFJDZ'},
    {label:'新疆汇和银行',value:'BOHH'},
    {label:'广东华兴银行',value:'GHB'},
    {label:'江南农村商业银行',value:'JNRCU'},
    {label:'深圳宝安融兴村镇银行',value:'BARXB'},
    {label:'南阳村镇银行',value:'NYCB'},
    {label:'河北银行股份有限公司',value:'BHB'},
    {label:'包商银行',value:'BSB'},
    {label:'濮阳银行',value:'PYYH'},
    {label:'宁波通商银行',value:'NBCB'},
    {label:'甘肃银行',value:'GSB'},
    {label:'上海农商银行',value:'SHRCB'},
    {label:'青岛农信',value:'QRCB'},
    {label:'福建省农村信用社联合社',value:'FJNX'},
    {label:'贵州省农村信用社联合社',value:'GZNXRU'},
    {label:'湖南省农村信用社联合社',value:'HNNXB'},
    {label:'海南省农村信用社联合社',value:'HNB'},
    {label:'广东南粤银行',value:'ZJCB'},
    {label:'无锡农村商业银行',value:'WXRCB'},
    {label:'枣庄银行',value:'ZHZB'},
    {label:'武汉农村商业银行',value:'WHRCB'},
    {label:'东亚银行',value:'BEA'},
    {label:'其他银行',value:'QTYH'}]

    export default bankList


// WEBPACK FOOTER //
// ./src/utils/bank.js